import { gql } from "@apollo/client";

export const getCardsQuery = gql`
query GetCardsandUsers($phone_number: String = "", $qr_code: String = "") {
  gogas_users(where: {phone_number: {_eq: $phone_number}}) {
    id
  }
  gogas_lpg_cards(where: {qr_code: {_eq: $qr_code}}) {
    extraa_user_id
    gogas_user_id
    id
    rfid
  }
  users(where: {phone_number: {_eq: $phone_number}}) {
    id
  }
  already_check: gogas_lpg_cards(where: {phone_number: {_eq: $phone_number}}) {
    extraa_user_id
    gogas_user_id
    id
  }
  gogas_new_registrations(where: {phone_number: {_eq: $phone_number}}) {
    id
  }
}
`

export const getCNGCardsQuery = gql`
query GetCngQrs($_eq: String = "") {
  cng_gogas_cards(where: {qr_code: {_eq: $_eq}}) {
    id
    qr_code
    user_id
    user {
      name
      phone_number
      wallet {
        balance
        id
        coin_type
      }
    }
  }
}
`

export const getLPGNewRegistrationQuery = gql`
query gogasNewReg($phone_number	: String = "") {
  gogas_new_registrations(limit: 1, where: {phone_number: {_eq: $phone_number}}) {
    id
    name
    phone_number
    erp_code
    station_name
    staff_number
    city
    state
    vehicle_number
    vehicle_type
    mobile_type
    image_url
    created_at
    redeem
    timestamp
  }
}
`